import { MemberTableSubject } from "@components/common/faro-table/faro-table-types";
import { CompanyMemberRole } from "@components/table/members/members-column/role-column/company-member-role";
import { GroupMemberRole } from "@components/table/members/members-column/role-column/group-member-role";
import { ProjectMemberRole } from "@components/table/members/members-column/role-column/project-member-role";
import { BaseCompanyIdProps } from "@custom-types/base-types";
import { MemberIdentityRoleProps } from "@custom-types/member-types";
import { SdbProject } from "@custom-types/project-types";
import { Text } from "@flat-ui";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { formatUserRoleType } from "@utils/data-display";

interface Props extends BaseCompanyIdProps, MemberIdentityRoleProps {
  /** The selected group if there is one */
  group?: FaroCoreApiTypes.GroupDetailResponse | null;

  /** The selected project if there is one */
  selectedProject?: SdbProject | null;

  /** Recognizes on which table subject this component is being used */
  subjectType: MemberTableSubject;

  /** Forces rendering a read-only role label instead of a dropdown */
  isReadOnly?: boolean;
}

/** Content to show for role member column */
export function RoleColumn({
  companyId,
  selectedProject,
  subjectType,
  memberIdentityRole,
  group,
  isReadOnly = false,
}: Props): JSX.Element | null {
  if (subjectType === "project" && selectedProject) {
    return (
      <ProjectMemberRole
        companyId={companyId}
        projectId={selectedProject?.id}
        memberIdentityRole={memberIdentityRole}
        isReadOnly={isReadOnly}
        location="role-column"
      />
    );
  }

  if (subjectType === "workspace" || subjectType === "team") {
    return (
      <CompanyMemberRole
        companyId={companyId}
        memberIdentityRole={memberIdentityRole}
        isReadOnly={isReadOnly}
        variant="tableCell"
        location="role-column"
      />
    );
  }

  if (subjectType === "group" && group) {
    return (
      <GroupMemberRole
        companyId={companyId}
        selectedGroup={group}
        memberIdentityRole={memberIdentityRole}
        isReadOnly={isReadOnly}
        location="role-column"
      />
    );
  }

  if (subjectType === "activeMembers") {
    return (
      <Text variant="bodyS">{formatUserRoleType(memberIdentityRole.role)}</Text>
    );
  }

  return null;
}
